import { render } from "./GestioneAziende.vue?vue&type=template&id=5bdd09dc&scoped=true"
import script from "./GestioneAziende.vue?vue&type=script&lang=js"
export * from "./GestioneAziende.vue?vue&type=script&lang=js"

import "./GestioneAziende.vue?vue&type=style&index=0&id=5bdd09dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdd09dc"]])

export default __exports__